export enum FontAwesomeIconStyle {
  Regular = 'regular',
  Solid = 'solid',
  Light = 'light',
  Thin = 'thin',
  Duotone = 'duotone'
}
